import * as React from 'react';
import { connect } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import NoteListItem from '../../NotesPage/NoteListItem';
import { Api } from '../../../typings/api';

interface SelectionDriveItemListPageProps extends AbstractDriveItemListPageProps {
	selectedResources: number[];
	selectedNotes: number[];
}

export class SelectionDriveItemListPage extends AbstractDriveItemListPage<SelectionDriveItemListPageProps> {
	headerLabel = 'messages.my_selection';
	noItemsLabel = 'messages.no_selection';
	hasShareButton = true;
	hasDownloadButton = true;
	hasBottomBar = true;

	initializeView(props: SelectionDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		return this.props.selectedResources;
	}

	renderAdditionalItems(): JSX.Element[] | null {
		const { selectedNotes, displayType } = this.props;

		if (!selectedNotes) {
			return null;
		}

		return selectedNotes.map(id => (
			<NoteListItem
				key={id}
				id={id}
				displayType={displayType}
				type={Api.AdditionalItemType.Note} // is needed for displaying in Coverflow mode
			/>
		));
	}

	getAdditionalItemsLength(): number {
		return this.props.selectedNotes.length;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { selection } = state;

	return {
		selectedResources: selection.resources,
		selectedNotes: selection.notes,
	};
};

export default connect(mapStateToProps)(SelectionDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Selection.tsx